// in src/posts.js
import React, { Fragment, useState, useEffect, createRef, useRef } from 'react';import { ListProps, TextInput, DateTimeInput, required, ReferenceInput, SelectInput, useRefresh, useCreate, useNotify, useUpdate, useRedirect, BooleanInput, TopToolbar, CreateButton, CheckboxGroupInput, Button, DeleteButton, FormDataConsumer, DateInput, useDataProvider, FormWithRedirect, FormTab, TabbedForm, RefreshButton, ShowButton, linkToRecord, NumberInput } from 'react-admin';import RichTextInput from 'ra-input-rich-text';

import { UserInput } from '../components/User';import { apiUrl, araTiquetsUrl, targets, timeZone } from './../common/constants';import { headersAPIObjectAuth } from './../common/utils';
import { CustomFieldsListTarget } from './../resources/custom_fields';
import { EventsSessionsList, SessionPricePeriodsUpdateDialog } from  './../resources/events_sessions';


import DownloadIcon from '@material-ui/icons/GetApp';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { CityInput } from './../components/Inputs';

import { parse } from "query-string";
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';

import { SaveButton, Toolbar } from 'react-admin';import { useForm, useFormState } from "react-final-form";
import Save from '@material-ui/icons/Save';
import { RadioButtonGroupInput } from 'react-admin';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconCancel from '@material-ui/icons/Cancel';
import DeleteIcon from '@material-ui/icons/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ConfirmationNumberIcon from '@mui/icons-material/ConfirmationNumber';
import { CompleteCalendar, getFilterValuesFromInterval as getCalendarFilterValuesFromInterval } from "@react-admin/ra-calendar";
import Grid from '@mui/material/Grid';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@material-ui/core/styles';
import { DocsList } from './docs';import { useHistory } from 'react-router-dom';

import { useTranslate, locales, getLanguageFromStorage } from '../common/language';import { validateMaxLength } from './../components/Validator';import { modules, modulesOptions  } from '../common/constants';
import { subscriptionModule, dateParser, toIsoString, utcDateParser  } from '../common/utils';
import { BoxPhotoUser } from './docs';
import { useAraTiquetsConfiguration } from '../common/useAraTiquetsConfiguration';

const descriptionToolbar = [
  [{ header: [2, 3, false] }],
  ['bold', 'italic', 'underline', 'strike'],
  [{ color: [] }, { background: [] }],
  [{ list: 'ordered' }, { list: 'bullet' }],
  [{ indent: '-1' }, { indent: '+1' }],
  [{ align: [] }],
  ['blockquote', 'code-block'],
  ['link', 'image', 'video'],
  ['clean'],
];

const enableRepetitiveEvents = false;

const normalizeImageSize = value => {
  const trimmed = value ? value.trim() : '';
  if (!trimmed || trimmed.toLowerCase() === 'auto') return false;
  return trimmed;
};

const formatImage = (quill, imageNode, width, height) => {
  const blot = quill.constructor.find(imageNode);
  if (!blot) return;

  const index = blot.offset(quill.scroll);
  quill.formatText(index, 1, 'width', width);
  quill.formatText(index, 1, 'height', height);
  quill.setSelection(index + 1, 0);
};

const promptImageSize = (quill, imageNode, translate) => {
  const currentWidth = imageNode.getAttribute('width') || '';
  const currentHeight = imageNode.getAttribute('height') || '';
  const widthInput = window.prompt(translate('events_topics.image_width_prompt'), currentWidth);
  if (widthInput === null) return;

  const heightInput = window.prompt(translate('events_topics.image_height_prompt'), currentHeight);
  if (heightInput === null) return;
  const width = normalizeImageSize(widthInput);
  const height = normalizeImageSize(heightInput);

  formatImage(quill, imageNode, width, height);
};

const configureDescriptionQuill = translate => quill => {
  quill.root.addEventListener('click', event => {
    if (event.target && event.target.tagName === 'IMG') {
      promptImageSize(quill, event.target, translate);
    }
  });
};

const CategoriesFilter = props => {
    const translate = useTranslate();
    return (<ReferenceInput                          
        label={translate('events.categories')}
        source="categories_id" 
        reference="events_categories" 
        filter={{ context: subscriptionModule(modules.FACM) ? 1 : 0 }} 
        perPage={1000}
        sort={{ field: 'order', order: 'ASC' }}
        alwaysOn
        className="filterCalendar"
    >
       <SelectInput optionText="name" optionValue="id" resettable />
    </ReferenceInput>);
};

const ClassroomsFilter = props => {
    const translate = useTranslate();
    return (<ReferenceInput                          
        label={translate('events.classroom')}
        source="classrooms_id" 
        reference="classrooms" 
        filter={{ associations_id: localStorage.getItem('associations_id'), onlyForEvents: true }}
        perPage={1000}
        sort={{ field: 'priority', order: 'ASC' }}
        alwaysOn
        className="filterCalendar"
        
    >
        <SelectInput optionText="name" optionValue="id" resettable />
    </ReferenceInput>);
};

const PublicFilter = props => {
    const translate = useTranslate();
    return (<SelectInput className="calendar-filter-select" label={translate('events.is_public_filter')} source="is_public" choices={[{id:1,name:translate('common.yes')},{id:0,name:translate('common.no')}]} resettable />);
};

const ShowFacFilter = props => {
    const translate = useTranslate();
    if (subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC))
        return (<SelectInput className="calendar-filter-select" label={translate('events.show_fac_filter')} source="show_fac" choices={[{id:1,name:translate('common.yes')},{id:0,name:translate('common.no')}]} resettable />);
    else
        return null;
};

const CalendarFilters = subscriptionModule(modules.CLASSROOMS) ? 
[<CategoriesFilter alwaysOn />,<ClassroomsFilter alwaysOn />,<PublicFilter alwaysOn />,<ShowFacFilter alwaysOn />]:
[<CategoriesFilter alwaysOn />,<PublicFilter alwaysOn />,<ShowFacFilter alwaysOn />];        

const EventsActions = (props) => {
    
    const link = createRef();
    const translate = useTranslate();
    const dataProvider = useDataProvider();    
    const notify = useNotify();
    const [showDialog, setShowDialog] = useState(false);
        
    const exportClick = () => {
        setShowDialog(true);
    }
    const handleCloseClick = () => {
        setShowDialog(false);
    }; 
        
    const handleSubmit = async values => {
        
        values.page=0;
        values.size=100000;
        values.sort='dateStart,ASC';
        values.calendar_sessions=true;

        const endPoint = subscriptionModule(modules.FACM) ? '/events/export/xls' : '/events/export/pdf';

        const url = new URL(apiUrl + endPoint);
        url.search = new URLSearchParams(values);

        const result = await fetch(url , { 
          headers: headersAPIObjectAuth()
        });

        const blob = await result.blob();
        const href = window.URL.createObjectURL(blob);
        link.current.download = translate('events.pdf_filename');
        link.current.href = href;
        link.current.click();
        notify(translate('common.download_ok'), 'success');
        setShowDialog(false);
    };  
                
    let filterExport = {
        associations_id : localStorage.getItem('associations_id'),        
    }
    
    var now = new Date();      
    var daysLater = new Date();   
    daysLater.setMinutes(daysLater.getMinutes()+6*24*60);

    filterExport.start_gte = now.toISOString(now);
    filterExport.start_lte = daysLater.toISOString(daysLater);        
            
    if ( props.filterValues.categories_id ) filterExport.categories_id = props.filterValues.categories_id;
    if ( props.filterValues.classrooms_id ) filterExport.classrooms_id = props.filterValues.classrooms_id;
    if ( props.filterValues.is_public !=null ) filterExport.is_public = props.filterValues.is_public;
    if ( props.filterValues.show_fac !=null ) filterExport.show_fac = props.filterValues.show_fac;
                
    /* Per exportaciÃ³ en CSV (client) */
    // <ExportButton maxResults="100000" filterValues={filterExport} alwaysEnabled={true} exporter={exporter} sort={{ field: 'dateStart', order: 'DESC' }} />  
    
    return (
    <>
    <TopToolbar>        
        <CreateButton/>   
        <Button onClick={exportClick} label={translate('ra.action.export')} ><DownloadIcon /></Button>     
        <ShowButton 
            component={Link}
            to={{
                pathname: `/public/events/list/${localStorage.getItem('friendly_url')}`
            }} 
            label={translate('public_events.view_web')}
            target="_blank"
        />
        <RefreshButton label=""/>
    </TopToolbar>
    <Dialog
            fullWidth
            open={showDialog}
            onClose={handleCloseClick}
            disableEnforceFocus
        >
            <DialogTitle>{translate('events.export_title')}</DialogTitle>

            <FormWithRedirect
                resource="events"                
                initialValues={ filterExport }
                save={handleSubmit}
                render={({
                    handleSubmitWithRedirect,
                    pristine,
                    saving
                }) => (
                    <>
                        <DialogContent>
                            <br />
                            {translate('events.export_form_text')}
                            <Grid container spacing={2}>
                                <Grid item xs={6}>     
                                    <DateInput fullWidth source="start_gte" validate={required()} label={translate('events.export_form_from')} />
                                </Grid> 
                                <Grid item xs={6}>     
                                    <DateInput fullWidth source="start_lte" validate={required()} label={translate('events.export_form_to')} />
                                </Grid> 
                            </Grid>                                                     
                        </DialogContent>
                        <DialogActions>
                            <Button label="ra.action.cancel" onClick={handleCloseClick}>
                                <IconCancel />
                            </Button>
                            <a role='button' ref={link} style={{ textDecoration: 'none', display: 'none' }} target="_blank"></a>
                            <SaveButton
                                handleSubmitWithRedirect={
                                    handleSubmitWithRedirect
                                }
                                pristine={pristine}
                                saving={saving}
                                icon={subscriptionModule(modules.FACM) ? <FileDownloadIcon/> : <PictureAsPdfIcon/>}
                                label={subscriptionModule(modules.FACM) ? translate('common.excel') : translate('common.pdf')}
                            />                  
                        </DialogActions>
                    </>
                )}
            />
        </Dialog>
    </>
    )
};

/*
SISTEMA VELL EXPORTACIÃ“ DES DE CLIENT (al final ho fem des de servidor, en un PDF)
const exporter = (items, translate, notify) => {
        
    const eventsForExport = items.map(event => {
        var eventForExport = {
            id : event.id,
            title : event.title, 
            date_start : event.start.substr(0,10) + ' ' + event.start.substr(11,5), 
            date_finish : event.end.substr(0,10) + ' ' + event.end.substr(11,5), 
            classrooms_name: event.classrooms_name,
            activities_name: event.activities_name,
            is_public: event.is_public ? translate('common.yes') : translate('common.no'),
            show_fac: event.show_fac ? translate('common.yes') : translate('common.no'),
            is_internal: event.is_internal ? translate('common.yes') : translate('common.no') 
        }
        return eventForExport;
    });
    jsonExport(eventsForExport, {
        headers: ['id', 'title', 'date_start', 'date_finish', 'classrooms_name', 'activities_name','is_public','show_fac','is_internal'],
        rename: [translate('events.exporter_header_id'), translate('events.exporter_header_title'), translate('events.exporter_header_date_start'), translate('events.exporter_header_date_finish'), translate('events.exporter_header_classrooms_name'), translate('events.exporter_header_activities_name'), translate('events.exporter_header_is_public')],        
        
    }, (err, csv) => {
        const csv_new = '\uFEFF' + csv;
        downloadCSV(csv_new, translate('events.exporter_file_name') ); 
        notify(translate('common.download_ok'),"success");
    });
};
*/


const getEventPublicLinks = event => {
  const isTicketing = event.ticketing === true || event.ticketing === 1 || event.ticketing === '1' || event.ticketing === 'true';
  const isAraTiquetsDraft = Number(event.ara_tiquets_status) === 0;
  const ticketingBaseUrl = event.friendly_url ? `${araTiquetsUrl}/events/${event.friendly_url}` : '';
  const ticketingUrl = isAraTiquetsDraft
    ? (event.hash_preview ? `${ticketingBaseUrl}?hash_preview=${encodeURIComponent(event.hash_preview)}` : '')
    : ticketingBaseUrl;

  return {
    ticketingUrl: isTicketing ? ticketingUrl : '',
    ticketingPreview: isTicketing && isAraTiquetsDraft,
    publicUrl: event.is_public && event.friendly_url ? '/#/public/events/'+event.friendly_url : ''
  };
};

const calendarLocalDate = value => {
  if (!value || typeof value !== 'string') {
    return value;
  }

  return value.replace(/([+-]\d{2}:?\d{2}|Z)$/, '');
};

const converter = (event: any): EventInput => {
  const publicLinks = getEventPublicLinks(event);
  const eventsId = event.events_id || event.id;

  return {
    id: String(event.id),
    title: event.title,
    start: calendarLocalDate(event.start),
    end: calendarLocalDate(event.end),
    backgroundColor: publicLinks.ticketingPreview ? '#ffb74d' : event.color,
    borderColor: publicLinks.ticketingPreview ? '#ffb74d' : event.color,
    editable: true,
    extendedProps: {
      eventsId: eventsId,
      eventsSessionsId: event.events_sessions_id,
      ticketingUrl: publicLinks.ticketingUrl,
      ticketingPreview: publicLinks.ticketingPreview,
      publicUrl: publicLinks.publicUrl
    }
  };
};

const eventSessionDateFields = [
    'date_start',
    'date_finish',
    'validators_start',
    'validators_finish',
    'open_doors_start'
];

const padDatePart = value => String(value).padStart(2, '0');

const getCalendarDateOffset = value => {
    try {
        const offsetPart = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            timeZoneName: 'shortOffset'
        }).formatToParts(value).find(part => part.type === 'timeZoneName');

        const match = offsetPart && offsetPart.value.match(/^GMT([+-])(\d{1,2})(?::(\d{2}))?$/);
        if (match) {
            return `${match[1]}${padDatePart(match[2])}:${padDatePart(match[3] || '0')}`;
        }
    } catch (error) {
        // Fallback for browsers without shortOffset support.
    }

    const offset = -value.getTimezoneOffset();
    const sign = offset >= 0 ? '+' : '-';
    const absOffset = Math.abs(offset);
    return `${sign}${padDatePart(Math.floor(absOffset / 60))}:${padDatePart(absOffset % 60)}`;
};

const eventSessionDateParser = value => {
    if (!value) {
        return value;
    }

    const date = new Date(value);

    return date.getUTCFullYear() +
        '-' + padDatePart(date.getUTCMonth() + 1) +
        '-' + padDatePart(date.getUTCDate()) +
        'T' + padDatePart(date.getUTCHours()) +
        ':' + padDatePart(date.getUTCMinutes()) +
        ':' + padDatePart(date.getUTCSeconds()) +
        getCalendarDateOffset(date);
};

const normalizeEventSessionForUpdate = data => {
    const normalized = { ...data };

    eventSessionDateFields.forEach(field => {
        if (normalized[field]) {
            normalized[field] = eventSessionDateParser(normalized[field]);
        }
    });

    return normalized;
};

const eventsCalendarStateKey = 'events_calendar_state';
const eventsCalendarStateEvent = 'events_calendar_state_changed';
const eventsCalendarRefreshEvent = 'events_calendar_refresh';

const getStoredEventsCalendarState = () => {
    try {
        const state = JSON.parse(sessionStorage.getItem(eventsCalendarStateKey));
        return {
            date: state && state.date ? state.date : null,
            view: state && state.view ? state.view : 'dayGridMonth'
        };
    } catch (error) {
        return { date: null, view: 'dayGridMonth' };
    }
};

const setStoredEventsCalendarDate = (date, notify = true) => {
    if (!date) {
        return;
    }

    const state = getStoredEventsCalendarState();
    const nextState = {
        date: date instanceof Date ? date.toISOString() : date,
        view: state.view || 'dayGridMonth'
    };

    sessionStorage.setItem(eventsCalendarStateKey, JSON.stringify(nextState));

    if (notify) {
        window.dispatchEvent(new CustomEvent(eventsCalendarStateEvent, { detail: nextState }));
    }
};

const refreshStoredEventsCalendar = () => {
    window.dispatchEvent(new CustomEvent(eventsCalendarRefreshEvent, { detail: Date.now() }));
};

export const EventsList = (props: ListProps) => {    
    
    const translate = useTranslate(); 
    const { name: araTiquetsName } = useAraTiquetsConfiguration();
    const viewAraTiquetsLabel = araTiquetsName
        ? translate('events.view_ara_tiquets').replace('%project_name%', araTiquetsName)
        : translate('events.view');
    const [createDialog, setCreateDialog] = useState(false);
    const [editDialog, setEditDialog] = useState(false);
    const [calendarState, setCalendarState] = useState(getStoredEventsCalendarState);
    const notify = useNotify();
    const refresh = useRefresh();
    const [update] = useUpdate();
    const dataProvider = useDataProvider();
    const [calendarRefreshKey, setCalendarRefreshKey] = useState(0);
    const [periodsDialogOpen, setPeriodsDialogOpen] = useState(false);
    const [selectedPeriodsStrategy, setSelectedPeriodsStrategy] = useState('SHIFT');
    const pendingCalendarChange = useRef();
    var history = useHistory();

    useEffect(() => {
        const handleStoredCalendarStateChanged = event => {
            if (event.detail) {
                setCalendarState(event.detail);
            }
        };

        window.addEventListener(eventsCalendarStateEvent, handleStoredCalendarStateChanged);

        return () => {
            window.removeEventListener(eventsCalendarStateEvent, handleStoredCalendarStateChanged);
        };
    }, []);

    useEffect(() => {
        const handleCalendarRefresh = event => {
            setCalendarRefreshKey(event.detail || Date.now());
            refresh();
        };

        window.addEventListener(eventsCalendarRefreshEvent, handleCalendarRefresh);

        return () => {
            window.removeEventListener(eventsCalendarRefreshEvent, handleCalendarRefresh);
        };
    }, [refresh]);
    
    const handleFailure = (error) => {   
        notify(error.message, 'error');
    };
    
    var handleEventClick = function (clickInfo) {                        
        const publicUrlTarget = clickInfo.jsEvent.target.closest('[data-calendar-public-url]');
        if (publicUrlTarget)
        {
            window.open(publicUrlTarget.getAttribute('data-calendar-public-url'), '_blank');
        }
        else
        {
            // SinÃ³, entenem que volem editar l'event        
            history.push(linkToRecord("events", clickInfo.event.extendedProps.eventsId || clickInfo.event.id));
        }
    };

    const updateCalendarSession = (changeInfo, periodsStrategy) => {
        const eventsSessionsId = changeInfo.event.extendedProps.eventsSessionsId;

        if (!eventsSessionsId) {
            return;
        }

        dataProvider.getOne('events_sessions', { id: eventsSessionsId })
            .then(({ data }) => {
                update(
                    {
                        type: 'update',
                        resource: 'events_sessions',
                        payload: {
                            id: eventsSessionsId,
                            data: {
                                ...normalizeEventSessionForUpdate(data),
                                date_start: eventSessionDateParser(changeInfo.event.start),
                                date_finish: changeInfo.event.end ? eventSessionDateParser(changeInfo.event.end) : null,
                                ...(periodsStrategy ? { price_periods_update_strategy: periodsStrategy } : {})
                            }
                        }
                    },
                    {
                        onSuccess: () => {
                            notify('ra.notification.updated', 'info', { smart_count: 1 }, true);
                            setStoredEventsCalendarDate(changeInfo.event.start, false);
                            refreshStoredEventsCalendar();
                        },
                        onFailure: error => {
                            notify(error.message, 'error');
                            changeInfo.revert();
                            refreshStoredEventsCalendar();
                        }
                    }
                );
            })
            .catch(error => {
                notify(error.message, 'error');
                changeInfo.revert();
                refreshStoredEventsCalendar();
            });
    };

    const handleEventChange = changeInfo => {
        if (!subscriptionModule(modules.TICKETS)) {
            updateCalendarSession(changeInfo);
            return;
        }

        pendingCalendarChange.current = changeInfo;
        setSelectedPeriodsStrategy('SHIFT');
        setPeriodsDialogOpen(true);
    };

    const closePeriodsDialog = () => {
        const pendingChange = pendingCalendarChange.current;
        pendingCalendarChange.current = undefined;
        setPeriodsDialogOpen(false);
        if (pendingChange) {
            pendingChange.revert();
        }
    };

    const saveCalendarChangeWithStrategy = () => {
        const pendingChange = pendingCalendarChange.current;
        pendingCalendarChange.current = undefined;
        setPeriodsDialogOpen(false);
        if (pendingChange) {
            updateCalendarSession(pendingChange, selectedPeriodsStrategy);
        }
    };

    const handleCalendarInterval = (dateInfo, filterValues = {}) => {
        if (dateInfo) {
            const nextState = {
                date: dateInfo.view && dateInfo.view.currentStart ? dateInfo.view.currentStart.toISOString() : dateInfo.startStr,
                view: dateInfo.view && dateInfo.view.type ? dateInfo.view.type : 'dayGridMonth'
            };

            sessionStorage.setItem(eventsCalendarStateKey, JSON.stringify(nextState));
            setCalendarState(previousState => previousState.date === nextState.date && previousState.view === nextState.view ? previousState : nextState);
        }

        return getCalendarFilterValuesFromInterval(dateInfo, filterValues);
    };
    
    return (
    <>
    <CompleteCalendar 
      key={calendarRefreshKey}
      {...props}
      ListProps={{
        perPage: 1000,
        filter: {associations_id : localStorage.getItem('associations_id'), calendar_sessions: true } , 
        filters : CalendarFilters,
        actions: <EventsActions/> ,
        basePath: "events" 
      }}
      CalendarProps={{
        locale: locales[getLanguageFromStorage()],
        timeZone: timeZone,
        mutationMode:"pessimistic",
        scrollTime: "08:00:00",
        slotDuration: '00:30:00',
        slotLabelInterval: "01:00",
        allDaySlot: false,
        initialDate: calendarState.date || undefined,
        initialView: calendarState.view,
        nowIndicator: true,
        height: 700, 
        displayEventTime: false,
        eventDisplay: 'block',
        editable:true,
        basePath: "events",
        convertToEvent: converter,
        getFilterValueFromInterval: handleCalendarInterval,
        eventClick: handleEventClick,
        eventChange: handleEventChange,
        eventContent : (eventContent) => {
            return(
                <Box className="events-calendar-icon">
                        <div className="events-calendar-title" title={eventContent.event.title}>{eventContent.event.title}</div>
                        <Box display="flex" alignItems="center" className="events-calendar-actions">
                            {eventContent.event.extendedProps.publicUrl ? <VisibilityIcon data-calendar-public-url={eventContent.event.extendedProps.publicUrl} titleAccess={translate('events.view_public_web')} aria-label={translate('events.view_public_web')} /> : null}
                            {eventContent.event.extendedProps.ticketingUrl ? <ConfirmationNumberIcon data-calendar-public-url={eventContent.event.extendedProps.ticketingUrl} titleAccess={eventContent.event.extendedProps.ticketingPreview ? translate('events.preview') : viewAraTiquetsLabel} aria-label={eventContent.event.extendedProps.ticketingPreview ? translate('events.preview') : viewAraTiquetsLabel} /> : null}
                        </Box>
                </Box>
                );}            
        ,
        /*
        Usem extendedProps per passar les URL de visualitzaciÃ³ de l'esdeveniment.
        */
       
        /*select: handleDateClick,*/
        /*eventDrop: function(info) {
            alert('eventDrop');            
        },
        eventDragStop: function(info) {
            alert('eventDragStop');
        },
        eventResize: function(info) {
            alert('eventResize');
        },
        eventResizeStop: function(info) {
            alert('eventResizeStop');
        },*/
      
      }}
      CreateDialogProps={{
        title: translate('events.create'),
        mutationMode:"pessimistic",
        fullWidth: true,
        maxWidth: 'lg',
      }}
      EditDialogProps={{
        title: translate('events.edit'),
        edit: true,
        mutationMode:"pessimistic",
        fullWidth: true,
        maxWidth: 'lg',
      }}
      CreateDialogForm={<CreateEventQuickForm />}
      EditDialogForm={<FormEvent araTiquetsName={araTiquetsName} />}
      onFailure={handleFailure}     
    >        
    </CompleteCalendar>
    <SessionPricePeriodsUpdateDialog
      open={periodsDialogOpen}
      value={selectedPeriodsStrategy}
      onChange={setSelectedPeriodsStrategy}
      onCancel={closePeriodsDialog}
      onSave={saveCalendarChangeWithStrategy}
    />
    </> );
}


const transformEventFormData = data => {
    const transformedData = { ...data };
    setStoredEventsCalendarDate(transformedData.start);
    transformedData.is_internal = transformedData.is_public !== true && transformedData.show_fac !== true && transformedData.ticketing !== true;

    if (transformedData.classrooms_id > 0) {
        const color = localStorage.getItem('classrooms_color') || null;
        return { ...transformedData, color };
    }

    return { ...transformedData, color: null };
};

const EventToolbar = (props) => {
    const redirect = useRedirect();
    const notify = useNotify();
    const translate = useTranslate(); 
    const dataProvider = useDataProvider();
    const refresh = useRefresh();

    const handleSaveSuccess = ({ data }) => {
        setStoredEventsCalendarDate(data && data.start ? data.start : props.record && props.record.start);
        refreshStoredEventsCalendar();
        notify('ra.notification.updated', 'info', { smart_count: 1 });
        redirect('/events');
        refresh();
    };
    
    return (
        <Toolbar {...props}>
            
            {props.record && props.record.repetitive_id && props.record.repetitive_id > 0 ?
                <SaveButtonWithEditionMode />
                :
                <SaveButton {...props} transform={transformEventFormData} onSuccess={handleSaveSuccess} />
            } 
            {props.record && props.record.repetitive_id && props.record.repetitive_id > 0 ?
                <DeleteButtonWithEditionMode />
                :
                <DeleteButton undoable={false} className="event_button_delete" />
            } 
            
        </Toolbar>
    );
};

const getEventCategoriesContext = () => subscriptionModule(modules.FACM) ? 1 : 0;

const EventCategoriesInput = ({ label }) => {
    const translate = useTranslate();
    const [choices, setChoices] = useState([]);
    const context = getEventCategoriesContext();

    useEffect(() => {
        fetch(apiUrl + '/ara-tiquets/events_categories/public?context=' + context, {
            headers: headersAPIObjectAuth()
        })
        .then(response => response.ok ? response.json() : [])
        .then(data => setChoices(Array.isArray(data) ? data : []))
        .catch(() => setChoices([]));
    }, [context]);

    if (!choices.length) {
        return null;
    }

    return (
        <CheckboxGroupInput
            label={label || translate('events.categories')}
            source="categories"
            choices={choices}
            optionText="name"
            optionValue="id"
            row={false}
            className="checkboxGroupInputCompacted"
        />
    );
};

const getDefaultEventDates = search => {
    const params = parse(search);
    if (params.start && params.end) {
        return { start: params.start, end: params.end };
    }

    const now = new Date();
    const hoursLater = new Date();
    hoursLater.setMinutes(hoursLater.getMinutes() + 2 * 60);

    return { start: toIsoString(now), end: toIsoString(hoursLater) };
};

export const CreateEventQuickForm = props => {
    const translate = useTranslate();
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();
    const location = useLocation();
    const [createEvent, { loading: creatingEvent }] = useCreate('events');
    const [createSession, { loading: creatingSession }] = useCreate('events_sessions');

    const dates = getDefaultEventDates(location.search);
    const hasTicketing = subscriptionModule(modules.TICKETS);
    const eventTypeChoices = hasTicketing ?
        [
            { id: 'without_registrations', name: translate('events.event_without_registrations') },
            { id: 'ticketing', name: translate('events.event_with_registrations_ticketing') }
        ] :
        [
            { id: 'without_registrations', name: translate('events.event_without_registrations') }
        ];
    const initialEventType = props.initialEventType || 'without_registrations';

    const handleSubmit = values => {
        const isTicketing = hasTicketing && values.event_type === 'ticketing';

        const eventValues = {
            associations_id: localStorage.getItem('associations_id'),
            activities_id: null,
            categories: [],
            title: values.title,
            start: values.start,
            end: values.end,
            repetitive_limit: values.start,
            repetitive_days: [],
            repetitive: false,
            reminder: 0,
            alert_days: -1,
            is_public: false,
            show_fac: false,
            xtac: false,
            is_internal: !isTicketing,
            ticketing: isTicketing
        };

        createEvent(
            { payload: { data: eventValues } },
            {
                onSuccess: ({ data }) => {
                    setStoredEventsCalendarDate(values.start);
                    createSession(
                        {
                            payload: {
                                data: {
                                    events_id: data.id,
                                    date_start: utcDateParser(values.start),
                                    date_finish: utcDateParser(values.end),
                                    maps_id: isTicketing && Number(values.has_seating_map) === 1 ? values.maps_id : null,
                                    total_capacity: isTicketing && Number(values.has_seating_map) === 1 ? null : values.total_capacity,
                                    default_price: isTicketing ? values.default_price : 0
                                }
                            }
                        },
                        {
                            onSuccess: () => {
                                redirect('/events/' + data.id);
                                refresh();
                            },
                            onFailure: error => {
                                notify(error.message, 'error');
                            }
                        }
                    );
                },
                onFailure: error => {
                    notify(error.message, 'error');
                }
            }
        );
    };

    return (
        <FormWithRedirect
            resource="events"
            initialValues={{
                title: '',
                start: dates.start,
                end: dates.end,
                event_type: initialEventType,
                has_seating_map: 0,
                default_price: 0,
                total_capacity: 1000
            }}
            save={handleSubmit}
            render={({
                handleSubmitWithRedirect,
                pristine,
                saving
            }) => (
                <>
                    <DialogContent>
                        <Grid container spacing={1}>
                            {hasTicketing ?
                            <Grid item xs={12}>
                                <RadioButtonGroupInput
                                    source="event_type"
                                    label={translate('events.event_type')}
                                    choices={eventTypeChoices}
                                    defaultValue={initialEventType}
                                    validate={[required()]}
                                />
                            </Grid>
                            : null}
                            <Grid item xs={12}>
                                <TextInput fullWidth source="title" label={translate('events.name')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                            </Grid>
                            <FormDataConsumer>
                                {({ formData, ...rest }) => formData.event_type === 'ticketing' &&
                                <Grid item xs={12}>
                                    <Box mt={1} mb={1} fontWeight="fontWeightBold">{translate('events.session_data')}</Box>
                                </Grid>
                                }
                            </FormDataConsumer>
                            <Grid item xs={12} sm={6}>
                                <DateTimeInput fullWidth source="start" label={translate('events.start')} validate={[required()]} parse={dateParser} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <DateTimeInput fullWidth source="end" label={translate('events.end')} validate={[required()]} parse={dateParser} />
                            </Grid>
                            {hasTicketing ?
                            <FormDataConsumer>
                                {({ formData, ...rest }) => formData.event_type === 'ticketing' &&
                                <>
                                    <Grid item xs={12}>
                                        <RadioButtonGroupInput
                                            source="has_seating_map"
                                            label={translate('events.seating_map')}
                                            choices={[
                                                { id: 0, name: translate('common.no') },
                                                { id: 1, name: translate('common.yes') }
                                            ]}
                                            defaultValue={0}
                                            validate={[required()]}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <NumberInput fullWidth source="default_price" label={translate('events.default_price')} defaultValue={0} />
                                    </Grid>
                                    {Number(formData.has_seating_map) === 1 ?
                                    <Grid item xs={12} sm={8}>
                                        <ReferenceInput
                                            fullWidth
                                            label={translate('events_sessions.map')}
                                            source="maps_id"
                                            filter={{ associations_id: localStorage.getItem('associations_id') }}
                                            reference="tickets_maps"
                                            perPage={1000}
                                            sort={{ field: 'id', order: 'ASC' }}
                                        >
                                           <SelectInput optionText="name" optionValue="id" validate={[required()]} />
                                        </ReferenceInput>
                                    </Grid>
                                    : null}
                                    {Number(formData.has_seating_map) !== 1 ?
                                    <Grid item xs={12} sm={4}>
                                        <NumberInput fullWidth source="total_capacity" label={translate('events.tickets_on_sale')} defaultValue={1000} validate={[required()]} />
                                    </Grid>
                                    : null}
                                    <Grid item xs={12}>
                                        <Box fontSize={13} color="text.secondary">{translate('events.ticketing_later_values_hint')}</Box>
                                    </Grid>
                                </>
                                }
                            </FormDataConsumer>
                            : null}
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        {props.onCancel ? (
                            <Button
                                onClick={props.onCancel}
                                label={translate('ra.action.cancel')}
                                disabled={creatingEvent || creatingSession}
                            >
                                <IconCancel />
                            </Button>
                        ) : null}
                        <SaveButton
                            handleSubmitWithRedirect={handleSubmitWithRedirect}
                            pristine={pristine}
                            saving={saving || creatingEvent || creatingSession}
                            disabled={creatingEvent || creatingSession}
                        />
                    </DialogActions>
                </>
            )}
        />
    );
};


               
export const SaveButtonWithEditionMode = ({ ...props }) => {

    const [showDialog, setShowDialog] = useState(false);
    const notify = useNotify();
    const refresh = useRefresh();    
    const translate = useTranslate();  
    const dataProvider = useDataProvider();
    const redirect = useRedirect();
    const formState = useFormState();

    const [update, { loading, error }] = useUpdate();

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const handleSubmit = async values => {
            
        update(
            { 
                type: 'update', 
                resource: 'events', 
                payload : { id: values.id, data : values }
            },
            {
                onSuccess: ({ data }) => {
                    setShowDialog(false);
                    redirect('/events');
                    refresh();
                },
                onFailure: ( error ) => {
                    notify(error.message, 'error');
                    setShowDialog(false);
                }
            }
        );
    };    
    
    return (
        <>
            <Button size="medium" variant="contained" onClick={handleClick} label={translate('events.repetitive_mode_edition_save')} startIcon={<Save />} />

            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label={translate('remittances.status_form')}
                disableEnforceFocus
            >
                <DialogTitle>{translate('events.repetitive_mode_edition_title_save')}</DialogTitle>

                <FormWithRedirect
                    resource="remittances_users_items"
                    save={handleSubmit}
                    initialValues={{ edition_mode : 0 , ...formState.values }}
                    render={({
                        handleSubmitWithRedirect,
                        pristine,
                        saving
                    }) => (
                        <>
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>     
                                        <RadioButtonGroupInput label="" row={false} source="edition_mode" choices={[
                                            { id: 0, name: translate('events.repetitive_mode_edition_only_one') },
                                            { id: 1, name: translate('events.repetitive_mode_edition_only_future') },
                                            { id: 2, name: translate('events.repetitive_mode_edition_all') },
                                        ]} />
                                    </Grid> 
                                </Grid>                                                     
                            </DialogContent>
                            <DialogActions>
                                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                                    <IconCancel />
                                </Button>
                                <SaveButton
                                    handleSubmitWithRedirect={
                                        handleSubmitWithRedirect
                                    }
                                    pristine={pristine}
                                    saving={saving}
                                    disabled={loading}
                                />
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    );
}


export const DeleteButtonWithEditionMode = ({ ...props }) => {

    const [showDialog, setShowDialog] = useState(false);
    const notify = useNotify();
    const refresh = useRefresh();    
    const translate = useTranslate();  
    const dataProvider = useDataProvider();
    const redirect = useRedirect();

    const [update, { loading, error }] = useUpdate();

    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const handleSubmit = async values => {
        
        if (window.confirm(translate('events.repetitive_mode_edition_delete_confirmation')))
            if (window.confirm(translate('events.repetitive_mode_edition_delete_confirmation_2')))
                dataProvider.delete('events/' + values.edition_mode , { id: values.id })
                    .then(( { data } ) => {   
                        setShowDialog(false);
                        redirect('/events');
                        refresh();
                    })
                    .catch(error => {     
                        notify(error.message, 'error');
                        setShowDialog(false);
                    });
            else
                setShowDialog(false);
        else
            setShowDialog(false);
            
    };    
    

    return (
        <>
            <Button size="medium" variant="text" onClick={handleClick} label={translate('events.repetitive_mode_edition_delete')} startIcon={<DeleteIcon />} className="event_button_delete" />

            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label={translate('remittances.status_form')}
                disableEnforceFocus
            >
                <DialogTitle>{translate('events.repetitive_mode_edition_title_delete')}</DialogTitle>

                <FormWithRedirect
                    resource="remittances_users_items"
                    save={handleSubmit}
                    initialValues={{ edition_mode : 0 , id: props.record.id }}
                    render={({
                        handleSubmitWithRedirect,
                        pristine,
                        saving
                    }) => (
                        <>
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>     
                                        <RadioButtonGroupInput label="" row={false} source="edition_mode" choices={[
                                            { id: 0, name: translate('events.repetitive_mode_edition_only_one') },
                                            { id: 1, name: translate('events.repetitive_mode_edition_only_future') },
                                            { id: 2, name: translate('events.repetitive_mode_edition_all') },
                                        ]} />
                                    </Grid> 
                                </Grid>                                                     
                            </DialogContent>
                            <DialogActions>
                                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                                    <IconCancel />
                                </Button>
                                <SaveButton 
                                    handleSubmitWithRedirect={
                                        handleSubmitWithRedirect
                                    }
                                    pristine={pristine}
                                    saving={saving}
                                    disabled={loading}
                                    label={translate('events.repetitive_mode_edition_delete')}
                                    icon={<DeleteIcon />}
                                />   
                                
                            </DialogActions>
                        </>
                    )}
                />
            </Dialog>
        </>
    );
}

const EventDataLayout = ({ isTicketingEvent, araTiquetsName }) => {
    const translate = useTranslate();
    const hasFacPublisherOrganizer = subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC_PUBLISHERS);
    const hasFacmOrganizer = subscriptionModule(modules.FACM);
    const showTicketsUrl = !isTicketingEvent;
    const organizerGridSize = showTicketsUrl ? 6 : 12;
    const ticketsUrlGridSize = hasFacPublisherOrganizer || hasFacmOrganizer ? 6 : 12;
    const panelStyle = {
        border: '1px solid #ddd',
        borderRadius: 4,
        padding: 16,
        backgroundColor: '#fff',
        minHeight: '100%',
        boxSizing: 'border-box'
    };
    const titleStyle = {
        margin: '0 0 16px 0',
        color: '#666',
        fontSize: 18,
        fontWeight: 500
    };
    const sectionStyle = {
        borderTop: '1px solid #eee',
        marginTop: 8,
        paddingTop: 16
    };
    const sectionTitleStyle = {
        margin: '0 0 12px 0',
        color: '#666',
        fontSize: 16,
        fontWeight: 500
    };
    return (
        <Grid container spacing={2}>
            <ColorInputHidden />
            <Grid item xs={12} md={8}>
                <Box style={panelStyle}>
                    <div style={titleStyle}>{translate('events.event_data')}</div>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextInput fullWidth source="title" autoFocus label={translate('events.name')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />
                        </Grid>
                        <Grid item xs={12}>
                            <RichTextInput fullWidth source="description" label={translate('common.description')} toolbar={descriptionToolbar} configureQuill={configureDescriptionQuill(translate)} className="events-description-input" />
                        </Grid>
                        { hasFacPublisherOrganizer ?
                        <Grid item xs={12} sm={organizerGridSize}>
                            <ReferenceInput
                                fullWidth
                                label={translate('events.organizer')}
                                source="organizers_id"
                                reference="organizers"
                                filter={{ associations_id: localStorage.getItem('associations_id') }}
                                perPage={1000}
                                sort={{ field: 'name', order: 'ASC' }}
                            >
                                <SelectInput optionText="name" optionValue="id" resettable />
                            </ReferenceInput>
                        </Grid>
                        : null }
                        { hasFacmOrganizer ?
                        <Grid item xs={12} sm={organizerGridSize}>
                            <UserInput source="users_id" user_type={-1} disabled={false} label={translate('events.organizer')} allowEmpty={false} required={false} />
                        </Grid>
                        : null }
                        { showTicketsUrl ?
                        <Grid item xs={12} sm={ticketsUrlGridSize}>
                            <TextInput fullWidth source="tickets_url" label={translate('events.tickets_url')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                        </Grid>
                        : null}
                        <Grid item xs={12}>
                            <Box style={sectionStyle}>
                                <div style={sectionTitleStyle}>{translate('events.place')}</div>
                            </Box>
                        </Grid>
                        { subscriptionModule(modules.CLASSROOMS) ?
                        <Grid item xs={12} sm={6}>
                            <ClassroomInput />
                        </Grid>
                        : null }
                        <Grid item xs={12} sm={subscriptionModule(modules.CLASSROOMS) ? 6 : 12}>
                            <TextInput fullWidth source="address" label={translate('events.address')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                        </Grid>
                        <Grid item xs={12}>
                            <CityInput />
                        </Grid>
                    </Grid>
                </Box>
            </Grid>
            <Grid item xs={12} md={4}>
                <Box style={panelStyle}>
                    <div style={titleStyle}>{translate('events.visibility')}</div>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <TextInput fullWidth source="friendly_url" label={translate('events.friendly_url')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                        </Grid>
                        <FormDataConsumer>
                            {({ formData, ...rest }) =>
                            <>
                                <Grid item xs={12}>
                                    <BooleanInput source="is_public" label={translate('events.is_public')} />
                                </Grid>
                                { subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC) || subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC_PUBLISHERS) ?
                                <Grid item xs={12}>
                                    <BooleanInput source="show_fac" label={translate('events.show_fac')} />
                                </Grid>
                                : null }
                                { subscriptionModule(modules.TICKETS) ?
                                <Grid item xs={12} sm={6}>
                                    <BooleanInput source="ticketing" label={araTiquetsName || translate('events.ticketing')} />
                                </Grid>
                                : null }
                                { subscriptionModule(modules.TICKETS) && formData.ticketing === true ?
                                <>
                                    <Grid item xs={12} sm={6}>
                                        <SelectInput
                                            fullWidth
                                            source="ara_tiquets_status"
                                            label={translate('events.ara_tiquets_status')}
                                            choices={[
                                                { id: 0, name: translate('events.ara_tiquets_draft') },
                                                { id: 1, name: translate('events.ara_tiquets_published') }
                                            ]}
                                            defaultValue={0}
                                        />
                                    </Grid>
                                </>
                                : null }
                                <Grid item xs={12}>
                                    <EventCategoriesInput />
                                </Grid>
                                { !isTicketingEvent && (subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC) || subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC_PUBLISHERS)) ?
                                <Grid item xs={12}>
                                    <BooleanInput source="xtac" label={translate('events.xtac')} />
                                </Grid>
                                : null }
                            </>
                            }
                        </FormDataConsumer>
                        { !isTicketingEvent && subscriptionModule(modules.ALERTS)?
                        <Grid item xs={12}>
                            <SelectInput fullWidth label={translate('events.alert_days')} source="alert_days" choices={[
                                { id: -1, name: translate('events.alert_days_none') },
                                { id: 0, name: translate('events.alert_days_0') },
                                { id: 1, name: translate('events.alert_days_1') },
                                { id: 2, name: translate('events.alert_days_2') },
                                { id: 3, name: translate('events.alert_days_3') },
                                { id: 4, name: translate('events.alert_days_4') },
                                { id: 5, name: translate('events.alert_days_5') },
                                { id: 6, name: translate('events.alert_days_6') },
                                { id: 7, name: translate('events.alert_days_7') },
                                { id: 8, name: translate('events.alert_days_8') },
                                { id: 9, name: translate('events.alert_days_9') },
                                { id: 10, name: translate('events.alert_days_10') },
                                { id: 11, name: translate('events.alert_days_11') },
                                { id: 12, name: translate('events.alert_days_12') },
                                { id: 13, name: translate('events.alert_days_13') },
                                { id: 14, name: translate('events.alert_days_14') }
                            ]}  />
                        </Grid> : null }
                        {enableRepetitiveEvents && !isTicketingEvent ?
                        <Grid item xs={12}>
                            <Box style={sectionStyle}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} className="generate_repetitive">
                                        <BooleanInput source="repetitive" label={translate('events.repetitive')} />
                                    </Grid>
                                    <FormDataConsumer>
                                        {({ formData, ...rest }) => formData.repetitive == true &&
                                        <>
                                            <Grid item xs={12} className="generate_repetitive" >
                                                <CheckboxGroupInput label="" source="repetitivedays" choices={[
                                                    { id: 1, name: translate('common.day_week_1') },
                                                    { id: 2, name: translate('common.day_week_2') },
                                                    { id: 3, name: translate('common.day_week_3') },
                                                    { id: 4, name: translate('common.day_week_4') },
                                                    { id: 5, name: translate('common.day_week_5') },
                                                    { id: 6, name: translate('common.day_week_6') },
                                                    { id: 7, name: translate('common.day_week_7') },
                                                ]}  />
                                            </Grid>
                                            <Grid item xs={12} className="generate_repetitive" >
                                                <DateInput fullWidth source="repetitive_limit" label={translate('events.repetitive_limit')} />
                                            </Grid>
                                        </>
                                        }
                                    </FormDataConsumer>
                                </Grid>
                            </Box>
                        </Grid>
                        : null}
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    );
};

const TicketPreviewButton = ({ eventId, record }) => {
    const translate = useTranslate();
    const notify = useNotify();
    const dataProvider = useDataProvider();
    const form = useForm();
    const { dirty, values, invalid, submitting } = useFormState({
        subscription: { dirty: true, values: true, invalid: true, submitting: true }
    });
    const [loading, setLoading] = useState(false);
    const [previewUrl, setPreviewUrl] = useState(null);
    const [showPreview, setShowPreview] = useState(false);
    const [showSaveConfirmation, setShowSaveConfirmation] = useState(false);

    useEffect(() => () => {
        if (previewUrl) window.URL.revokeObjectURL(previewUrl);
    }, [previewUrl]);

    const loadPreview = async () => {
        setLoading(true);
        try {
            const response = await fetch(`${apiUrl}/events/${eventId}/ticket-preview`, {
                headers: {
                    ...headersAPIObjectAuth(),
                    Accept: 'application/pdf'
                }
            });

            if (!response.ok) {
                let message = translate('tickets_ticket.download_error');
                try {
                    const error = await response.json();
                    message = error.message || message;
                } catch (error) {
                    // La resposta d'error no sempre conté JSON.
                }
                throw new Error(message);
            }

            const blob = await response.blob();
            const href = window.URL.createObjectURL(blob);
            setPreviewUrl(href);
            setShowPreview(true);
        } catch (error) {
            notify(error.message || translate('tickets_ticket.download_error'), 'warning');
        } finally {
            setLoading(false);
        }
    };

    const handlePreview = () => {
        if (dirty) {
            setShowSaveConfirmation(true);
            return;
        }

        loadPreview();
    };

    const handleSaveAndPreview = async () => {
        if (invalid) {
            setShowSaveConfirmation(false);
            notify('ra.message.invalid_form', 'warning');
            return;
        }

        setLoading(true);
        try {
            const response = await dataProvider.update('events', {
                id: eventId,
                data: transformEventFormData(values),
                previousData: record
            });
            form.initialize({ ...values, ...response.data });
            notify('ra.notification.updated', 'info', { smart_count: 1 });
            setShowSaveConfirmation(false);
            await loadPreview();
        } catch (error) {
            notify(error.message || translate('ra.notification.http_error'), 'warning');
        } finally {
            setLoading(false);
        }
    };

    const handleClose = () => {
        setShowPreview(false);
        setPreviewUrl(null);
    };

    const handleDownload = () => {
        if (!previewUrl) return;
        const link = document.createElement('a');
        link.href = previewUrl;
        link.download = 'entrada-prova.pdf';
        document.body.appendChild(link);
        link.click();
        link.remove();
    };

    return (
        <>
            <Button onClick={handlePreview} disabled={loading || submitting} label={translate('tickets_ticket.preview')}>
                <PictureAsPdfIcon />
            </Button>
            <Dialog open={showSaveConfirmation} onClose={() => setShowSaveConfirmation(false)} maxWidth="sm" fullWidth>
                <DialogTitle>{translate('tickets_ticket.preview_save_title')}</DialogTitle>
                <DialogContent dividers>
                    {translate('tickets_ticket.preview_save_message')}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setShowSaveConfirmation(false)} disabled={loading} label="ra.action.cancel">
                        <IconCancel />
                    </Button>
                    <Button onClick={handleSaveAndPreview} disabled={loading} label={translate('tickets_ticket.preview_save_confirm')}>
                        <Save />
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={showPreview}
                onClose={handleClose}
                maxWidth="xl"
                fullWidth
                PaperProps={{ style: { height: '92vh' } }}
            >
                <DialogTitle style={{ position: 'relative', paddingRight: 56 }}>
                    {translate('tickets_ticket.preview')}
                    <IconButton
                        onClick={handleClose}
                        aria-label={translate('ra.action.close')}
                        style={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers style={{ padding: 0, overflow: 'auto', display: 'flex' }}>
                    {previewUrl && (
                        <iframe
                            src={`${previewUrl}#toolbar=0&navpanes=0&scrollbar=1&view=FitH&page=1`}
                            title={translate('tickets_ticket.preview')}
                            scrolling="yes"
                            style={{ width: '100%', flex: 1, border: 0 }}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDownload} label={translate('tickets_ticket.download')}>
                        <FileDownloadIcon />
                    </Button>
                    <Button onClick={handleClose} label="ra.action.close">
                        <IconCancel />
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};


const FormEvent = props => {
    
    const translate = useTranslate(); 
    const araTiquetsName = props.araTiquetsName;
    const [editDialog, setEditDialog] = useState(false);
    const [createDialog, setCreateDialog] = useState(false);
    const [create, { loading }] = useCreate('events');
    const notify = useNotify();
    const refresh = useRefresh();  
    var redirect = useRedirect();
    const location = useLocation();
    const dataProvider = useDataProvider();
    const classes = useStyles();
    const [cities, setCities] = useState();
    const isTicketingEvent = props.record && props.record.ticketing === true;
                        
    const params = parse(location.search);
    
    
    
    if (params.start && params.end)
    {
        var dt_start = params.start;
        var dt_end = params.end;
    }
    else
    {        
        var now = new Date();      
        var hoursLater = new Date();   
        hoursLater.setMinutes(hoursLater.getMinutes()+2*60);
    
        var dt_start = toIsoString(now);
        var dt_end = toIsoString(hoursLater);
    }
    
    //const today = new Date().toISOString().slice(0, 10);
    const today = dt_start;
                                    
    return (
        <TabbedForm
            {...props}            
            initialValues={{ associations_id: localStorage.getItem('associations_id'), start: dt_start, end: dt_end, repetitive_limit: today , repetitive_days: [], reminder: 0, alert_days: -1 }}
            mutationMode="pessimistic"
            toolbar={<EventToolbar {...props}  />} 
            title=""   
        >        
            <FormTab
                label={translate('events.data')}
                contentClassName={classes.tab}
                path=""   
            > 
            
            {true ? 
            <FormDataConsumer>
                {({ formData, ...rest }) => <EventDataLayout isTicketingEvent={isTicketingEvent || formData.ticketing === true} araTiquetsName={araTiquetsName} />}
            </FormDataConsumer>
            :
            <Grid container spacing={1} >
                <Grid item xs={12} sm={7}>
                        
                        
                    <Grid container spacing={1} >
                        {!isTicketingEvent ?
                        <Grid item xs={12} sm={subscriptionModule(modules.CLASSROOMS) ? 6 : 12}>

                            <ReferenceInput 
                                fullWidth 
                                label={translate('events.activity')} 
                                source="activities_id" 
                                reference="activities" 
                                filter={{ target: subscriptionModule(modules.FACM) ? 1 : 0 }} 
                                perPage={1000}
                                sort={{ field: 'priority', order: 'ASC' }}
                            >
                               <SelectInput optionText="name" optionValue="id" validate={[required()]} />
                            </ReferenceInput>                    
                        </Grid>
                        : null}
                        
                        { subscriptionModule(modules.CLASSROOMS) ?
                        <Grid item xs={12} sm={6}>
                            <ClassroomInput />                                
                        </Grid>
                        : null }

                        <ColorInputHidden />

                        <Grid item xs={12} sm={12}>
                            <TextInput fullWidth source="title" autoFocus label={translate('events.name')} validate={[required(),validateMaxLength(100,translate('common.validation.maxLength'))]} />                             
                        </Grid>
                                                
                        <Grid item xs={12} sm={12}>
                            <RichTextInput fullWidth source="description" label={translate('common.description')} toolbar={descriptionToolbar} configureQuill={configureDescriptionQuill(translate)} className="events-description-input" />
                        </Grid>
                        {!isTicketingEvent ?
                        <Grid item xs={12} sm={6}>
                            <DateTimeInput fullWidth source="start" label={translate('events.start')} validate={[required()]} parse={dateParser} />
                        </Grid>
                        : null}
                        {!isTicketingEvent ?
                        <Grid item xs={12} sm={6}>
                            <DateTimeInput fullWidth source="end" label={translate('events.end')} validate={[required()]} parse={dateParser} />
                        </Grid>
                        : null}
                        
                        {!isTicketingEvent ?
                        <Grid item xs={12} sm={6}>      
                            <SelectInput fullWidth label={translate('bookings.reminder')} source="reminder" choices={[
                                { id: 0, name: translate('bookings.reminder_0') },
                                { id: 1, name: translate('bookings.reminder_1') },
                                { id: 2, name: translate('bookings.reminder_2') },
                                { id: 3, name: translate('bookings.reminder_3') },
                                { id: 4, name: translate('bookings.reminder_4') },
                                { id: 5, name: translate('bookings.reminder_5') },
                                { id: 6, name: translate('bookings.reminder_6') },
                                { id: 7, name: translate('bookings.reminder_7') },
                                { id: 8, name: translate('bookings.reminder_8') }
                            ]}  />
                        </Grid> 
                        : null}
                        
                        { subscriptionModule(modules.ALERTS)?
                        <Grid item xs={12} sm={6}>      
                            <SelectInput fullWidth label={translate('events.alert_days')} source="alert_days" choices={[
                                { id: -1, name: translate('events.alert_days_none') },
                                { id: 0, name: translate('events.alert_days_0') },
                                { id: 1, name: translate('events.alert_days_1') },
                                { id: 2, name: translate('events.alert_days_2') },
                                { id: 3, name: translate('events.alert_days_3') },
                                { id: 4, name: translate('events.alert_days_4') },
                                { id: 5, name: translate('events.alert_days_5') },
                                { id: 6, name: translate('events.alert_days_6') },
                                { id: 7, name: translate('events.alert_days_7') },
                                { id: 8, name: translate('events.alert_days_8') },
                                { id: 9, name: translate('events.alert_days_9') },
                                { id: 10, name: translate('events.alert_days_10') },
                                { id: 11, name: translate('events.alert_days_11') },
                                { id: 12, name: translate('events.alert_days_12') },
                                { id: 13, name: translate('events.alert_days_13') },
                                { id: 14, name: translate('events.alert_days_14') }
                            ]}  />
                        </Grid> : null }   
                        
                        {!isTicketingEvent ?
                        <Grid item xs={12} sm={12}>
                            <TextInput fullWidth source="tickets_url" autoFocus label={translate('events.tickets_url')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />                             
                        </Grid>
                        : null}

                    </Grid>
                                        
                </Grid>
                <Grid item xs={12} sm={1}>
                </Grid>
                <Grid item xs={12} sm={4}>
                
                    <Grid container spacing={1} >
                        
                        <Grid item xs={12} sm={12}>
                            <BooleanInput source="is_public" label={translate('events.is_public')} />
                        </Grid>
                        
                        { subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC) || subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC_PUBLISHERS) ?
                        <Grid item xs={12} sm={12}>
                            <BooleanInput source="show_fac" label={translate('events.show_fac')} />                            
                        </Grid>
                        : null }
                        
                        { subscriptionModule(modules.TICKETS) ?
                        <Grid item xs={12} sm={12}>
                            <BooleanInput source="ticketing" label={araTiquetsName || translate('events.ticketing')} />
                        </Grid>
                        : null }

                        { subscriptionModule(modules.TICKETS) ?
                        <FormDataConsumer>
                            {({ formData, ...rest }) => formData.ticketing === true &&
                            <Grid item xs={12} sm={12}>
                                <EventCategoriesInput />
                            </Grid>
                            }
                        </FormDataConsumer>
                        : null }
                        
                        { subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC) || subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC_PUBLISHERS) ?
                        <Grid item xs={12} sm={12}>
                            <BooleanInput source="xtac" label={translate('events.xtac')} />                            
                        </Grid>
                        : null }
                                                
                        <Grid item xs={12}>                                               
                            <TextInput fullWidth source="friendly_url" label={translate('events.friendly_url')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                        </Grid>
                        
                        { subscriptionModule(modules.CALENDAR,modulesOptions.CALENDAR_FAC_PUBLISHERS) ?                        
                        <Grid item xs={12} sm={12}>
                            <ReferenceInput 
                                fullWidth 
                                label={translate('events.organizer')} 
                                source="organizers_id" 
                                reference="organizers" 
                                filter={{ associations_id: localStorage.getItem('associations_id') }}
                                perPage={1000}
                                sort={{ field: 'name', order: 'ASC' }}
                            >
                                <SelectInput optionText="name" optionValue="id" resettable />                        
                            </ReferenceInput>              
                        </Grid>
                        : null }
                        
                        { subscriptionModule(modules.FACM) ?                        
                        <Grid item xs={12} sm={12}>
                            <UserInput source="users_id" user_type={-1} disabled={false} label={translate('events.organizer')} allowEmpty={false} required={false} />
                        </Grid>
                        : null }
                        
                        <Grid item xs={12} sm={12}>
                            <TextInput fullWidth source="address" label={translate('events.address')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />                             
                        </Grid>
                        
                        <Grid item xs={12} sm={12}>
                            <CityInput />
                        </Grid>
                        
                        { /* !subscriptionModule(modules.FACM) ? 
                        <Grid item xs={12} sm={12} className="events_labels">

                            <ReferenceArrayInput
                                source="labels"
                                reference="labels"
                                filter={{ type: 1 }}
                                perPage={1000}
                                sort={{ field: 'priority', order: 'ASC' }}
                            >
                                <CheckboxGroupInput 
                                    optionText="name" 
                                    optionValue="id"
                                    label={translate('common.labels')}            
                                    row={true}
                                    className="checkboxGroupInputCompacted"  
                                />
                            </ReferenceArrayInput>        

                        </Grid>   
                        : null */ }

                        {enableRepetitiveEvents && !isTicketingEvent ?
                        <Grid item xs={12} sm={12} className="generate_repetitive mt10" >                        
                            <BooleanInput source="repetitive" label={translate('events.repetitive')} />
                        </Grid>  
                        : null}

                        {enableRepetitiveEvents && !isTicketingEvent ?
                        <FormDataConsumer>  
                            {({ formData, ...rest }) => formData.repetitive == true &&   

                            <>
                            <Grid item xs={12} sm={12} className="generate_repetitive" >             

                            <CheckboxGroupInput label="" source="repetitivedays" choices={[
                                { id: 1, name: translate('common.day_week_1') },
                                { id: 2, name: translate('common.day_week_2') },
                                { id: 3, name: translate('common.day_week_3') },
                                { id: 4, name: translate('common.day_week_4') },
                                { id: 5, name: translate('common.day_week_5') },
                                { id: 6, name: translate('common.day_week_6') },
                                { id: 7, name: translate('common.day_week_7') },
                            ]}  />

                            </Grid> 
                            <Grid item xs={12} sm={12} className="generate_repetitive" > 
                            <DateInput fullWidth source="repetitive_limit" label={translate('events.repetitive_limit')} />
                            </Grid> 
                            </>

                            }                    
                        </FormDataConsumer>  
                        : null}
                    
                    </Grid>  
                                
                </Grid>
                
            </Grid>}
                
            </FormTab>  
            
            {props.record && props.record.id ? 
            <FormTab
                label={translate('events_sessions.title')}
                contentClassName={classes.tab}
                path="sessions"                 
            > 
                <EventsSessionsList events_id={props.record.id} ticketing={props.record.ticketing === true} />
                
            </FormTab>
            : null }
            
            {props.record && props.record.id ? 
            <FormTab
                label={translate('events.images')}
                contentClassName={classes.tab}
                path="images"                 
            > 
                <DocsList target={targets.EVENT_IMAGE} items_id={props.record.id} mark={true} mark_title={translate('events.docs_mark')} />
                <br /><span>{translate('events.images_desc')}</span>
            </FormTab>
            : null }
        
            {props.record && props.record.id ? 
            <FormTab
                label={translate('events.docs')}
                contentClassName={classes.tab}
                path="docs"                 
            > 
                <DocsList target={targets.EVENT} items_id={props.record.id} mark={true} mark_title={translate('events.docs_mark')} />
                <br /><span>{translate('events.docs_desc')}</span>
            </FormTab>
            : null }
        
            {props.record && props.record.id && props.record.ticketing && subscriptionModule(modules.CUSTOM_FIELDS) && subscriptionModule(modules.TICKETS) ? 
            <FormTab
                label={translate('tickets_custom_fields.title')}
                contentClassName={classes.tab}
                path="custom_fields"                 
            > 
                <CustomFieldsListTarget target={targets.EVENT} events_id={props.record.id} />
                
            </FormTab>
            : null }
            
            {props.record && props.record.id && props.record.ticketing && subscriptionModule(modules.TICKETS) ? 
            <FormTab
                label={translate('tickets_ticket.title')}
                contentClassName={classes.tab}
                path="ticket"                 
            > 
                <Grid container spacing={2} >
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <TicketPreviewButton eventId={props.record.id} record={props.record} />
                    </Grid>

                    <Grid item xs={12} md={4}>
                        <b>{translate('tickets_ticket.main_image')}</b><br /><br />
                        <BoxPhotoUser target={targets.TICKETS_TICKET_IMAGE} items_id={props.record.id} edit={true} default_img={3} className="tickets_ticket_edit_image" />
                    </Grid>

                    <Grid item md={1} />

                    <Grid item xs={12} md={7}>
                        <Grid container spacing={1}>
                            <Grid item xs={12}>
                                <br />
                                <TextInput fullWidth multiline source="ticket_primary_text" label={translate('tickets_ticket.primary_text')} />
                            </Grid>
                            <Grid item xs={12}>
                                <BooleanInput source="ticket_show_prices" label={translate('tickets_ticket.show_prices')} />
                            </Grid>
                            <Grid item xs={12}>
                                <BooleanInput source="ticket_show_custom_fields" label={translate('tickets_ticket.show_custom_fields')} />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <TextInput fullWidth multiline source="ticket_secondary_text" label={translate('tickets_ticket.secondary_text')} />
                    </Grid>
                    
                    <Grid item xs={12}>
                        <b>{translate('tickets_ticket.ads_image')}</b><br /><br />
                        <BoxPhotoUser target={targets.TICKETS_TICKET_AD} items_id={props.record.id} edit={true} default_img={3} className="tickets_ticket_edit_image" />
                    </Grid>
            
                </Grid>
                
            </FormTab>
            : null }
        
        </TabbedForm>
    )
}

const ClassroomInput = ({ valor, ...props }) => {

    const translate = useTranslate(); 
    const dataProvider = useDataProvider();
    const { change } = useForm();
  
    const handleChangeClassroom = (event) => {
        
        if (event.target && event.target.value && event.target.value > 0)
        {
            const classrooms_id = event.target.value;

            dataProvider.getOne('classrooms', { id: classrooms_id })
            .then(( { data } ) => {   
                change('address', data.address);
                change('cities_id', data.cities_id);
            })
            .catch(error => {                

            });
        }        
    };
  
    return (
      <ReferenceInput 
          fullWidth 
          label={translate('events.classroom')} 
          source="classrooms_id" 
          reference="classrooms" 
          filter={{ associations_id: localStorage.getItem('associations_id'), onlyForEvents: true }}
          perPage={1000}
          sort={{ field: 'priority', order: 'ASC' }}
          onChange={handleChangeClassroom}
      >
          <SelectInput optionText="name" optionValue="id" resettable  />                        
      </ReferenceInput>  
      );
};

export const ColorInputHidden = ({ ...props }) => {
    
    const dataProvider = useDataProvider();
    const { values } = useFormState();
    const [color, setColor] = React.useState(false);      
    
    useEffect(() => {
        
        if (values.classrooms_id)
            dataProvider.getOne('classrooms', { id: values.classrooms_id })
            .then(( { data } ) => {   
                setColor(data.color);
            })
            .catch(error => {                
                setColor(null);
            });
        else
            setColor(null);
        
      }, [values.classrooms_id]);
    
    if (!color) {
        localStorage.removeItem('classrooms_color');        
    }
    else{
        localStorage.setItem('classrooms_color', color );
    }
    return null;
  
}

const useStyles = makeStyles({
    comment: {
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
    },
    tab: {
        maxWidth: '100%',
        display: 'block',
    },
});


